import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../Text';
import TextInput from '../../FormStyles/TextInput';
import { Button } from '../../FormStyles/Button';

const allowlistedURIs = [
  'www.youtube.com',
  'player.vimeo.com',
  'fast.wistia.net',
  'embed.ted.com',
  'cdnapisec.kaltura.com',
  'media.hartfordhealthcare.org',
  'play.vidyard.com',
  'players.brightcove.net',
  'www.brainshark.com',
];

const EmbedVideo = ({ setEmbedVideo, closeContent }) => {
  const { t } = useTranslation('tileForm');
  const [value, setValue] = useState('');
  const [isValid, setIsValid] = useState();

  const sanitizeIframe = inputValue => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(inputValue, 'text/html');
    const iframe = doc.querySelector('iframe');

    if (!iframe) return false;

    const { src } = iframe;

    const anchor = document.createElement('a');
    anchor.href = src;

    return allowlistedURIs.includes(anchor.hostname) && iframe.outerHTML;
  };

  const handleChange = inputValue => {
    setValue(inputValue);
    const iframe = sanitizeIframe(inputValue);

    if (iframe) {
      setIsValid(true);
      setEmbedVideo({ videoIframe: iframe });
    } else {
      setIsValid(false);
    }
  };

  return (
    <>
      <EmbedHelp
        href={t('media.helpEmbedVideoLink')}
        as="a"
        color="primary.100"
      >
        {t('media.helpEmbedVideo')}
      </EmbedHelp>
      <TextInput
        placeholder={t('media.embedVideoInputPlaceholder')}
        as="textarea"
        value={value}
        onChange={e => handleChange(e.target.value)}
      />
      {isValid === false && (
        <Text as="div" color="error.default" pt="16px">
          {t('media.invalidEmbedUrl')}
        </Text>
      )}
      <Button
        variant="containedBlue"
        width="100%"
        mt="20px"
        onClick={closeContent}
      >
        {t('media.closeSearch')}
      </Button>
    </>
  );
};

export default EmbedVideo;

const EmbedHelp = styled(Text)`
  display: flex;
`;
